import { render } from "./InsightsDashboard.vue?vue&type=template&id=a8b0d8a0"
import script from "./InsightsDashboard.vue?vue&type=script&lang=js"
export * from "./InsightsDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/InsightsDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8b0d8a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8b0d8a0', __exports__)) {
    api.reload('a8b0d8a0', __exports__)
  }
  
  module.hot.accept("./InsightsDashboard.vue?vue&type=template&id=a8b0d8a0", () => {
    api.rerender('a8b0d8a0', render)
  })

}


export default __exports__